import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import { Link } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import logo from '../logo.png';
const pages = [
  'Home',
  'Deer',
  'Turkey',
  'Packages',
  'Contact us',
  'Testimonials',
  'Videos',
  'Photo Gallery',
];

function NavBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  // Map page names to their corresponding routes
  const pageRoutes = {
    Home: '/',
    Deer: '/',
    Turkey: '/',
    Packages: '/',
    'Contact us': '/',
    Testimonials: '/',
    'Photo Gallery': '/',
    Videos: '/',
  };
  const pageSectionIds = {
    Home: 'home-section',
    Deer: 'deer-section',
    Turkey: 'turkey-section',
    Packages: 'packages-section',

    Testimonials: 'testimonials-section',
    Links: 'links-section',
    'Contact us': 'contact-section',
    'Photo Gallery': 'gallery-section',
    Videos: 'videos-section',
  };
  // Helper to scroll to section by id
  const handleScrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const yOffset = -100;
      const y =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
    handleCloseNavMenu();
  };

  // Map page names to section IDs (for scrolling)

  return (
    <AppBar component="nav" sx={{ backgroundColor: 'black' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{
              height: 50,
              width: 'auto',
              marginRight: 2,
            }}
          />

          <Box
            sx={{
              flexGrow: 0,
              display: { xs: 'flex', md: 'none' },
              marginLeft: 'auto',
            }}
          >
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              {pages.map((page) => (
                <MenuItem
                  className="mobileLink"
                  key={page}
                  component={Link}
                  to={pageRoutes[page]}
                  onClick={() => handleScrollToSection(pageSectionIds[page])}
                >
                  <Typography sx={{ textAlign: 'center' }}>{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}></Box>
          <Box
            id="Menu"
            sx={{
              flexGrow: 0,
              display: { xs: 'none', md: 'flex', lg: 'flex' },
            }}
          >
            {pages.map((page) => (
              <MenuItem
                className="desktopLink"
                key={page}
                component={Link}
                to={pageRoutes[page]}
                onClick={() => handleScrollToSection(pageSectionIds[page])}
              >
                <Typography sx={{ textAlign: 'center' }}>{page}</Typography>
              </MenuItem>
            ))}
            {/* {pages.map((page) => (
              <Button
                component={Link}
                to={pageRoutes[page]}
                onClick={() => handleScrollToSection(pageSectionIds[page])}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page}
              </Button>
            ))} */}
            {/* <Button
              component={Link}
              to="/"
              sx={{ my: 2, color: 'white', display: 'block' }}
              onClick={handleCloseNavMenu}
            >
              Home
            </Button>
            <Button
              component={Link}
              to="/"
              sx={{ my: 2, color: 'white', display: 'block' }}
              onClick={() => handleScrollToSection(pageSectionIds['Deer'])}
            >
              Deer
            </Button> */}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default NavBar;
